import React from 'react';
import ErrorFallback from '../../pages/ErrorFallback/ErrorFallback';

/**
 * ErrorBoundary — catches any runtime JS errors in the subtree and renders
 * ErrorFallback instead of a blank/crashed page.
 *
 * Usage:
 *   <ErrorBoundary>
 *     <YourComponent />
 *   </ErrorBoundary>
 */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('[ErrorBoundary] Caught an error:', error, errorInfo);
        // You can pipe to an error-reporting service here (e.g. Sentry)
    }

    resetErrorBoundary() {
        this.setState({ hasError: false, error: null });
    }

    render() {
        if (this.state.hasError) {
            const FallbackComponent = this.props.FallbackComponent || ErrorFallback;
            return (
                <FallbackComponent
                    error={this.state.error}
                    resetErrorBoundary={this.resetErrorBoundary}
                />
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
